import styled from "styled-components";
import theme from "../../../styles/theme";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 0;
  width: 100%;
`;

export const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
  color: black;
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  border-style: solid;
  border-width: 1px;
  border-color: #dadce0;
  border-radius: 25px;
  padding: 42px 24px 36px;
  width: min(86vw, 1120px);
  min-height: 230px;
  box-sizing: border-box;
  background: #ffffff;
  .left-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #5f6368;
    width: 100%;
    flex: 1;
    .left-image {
      width: 250px;
      margin-left: -15px;
      @media (${theme.devices.tablet}) {
        margin-left: 0px;
        place-self: center;
      }
    }
    .left-title {
      font-family: ${theme.fonts.gilroySemiBold};
      font-size: 48px;
      margin-top: 4vh;
      margin-left: -1px;
      @media (${theme.devices.tablet}) {
        margin-left: 0px;
        place-self: center;
        margin-top: 2vh;
      }
    }
    .left-subtitle {
      font-family: ${theme.fonts.gilroyRegular};
      font-size: ${theme.fontSize.md};
      white-space: nowrap;
      @media (${theme.devices.tablet}) {
        white-space: normal;
        margin-left: 0px;
        place-self: center;
        font-size: 16px;
        margin-top: 1vh;
      }
    }
    @media (${theme.devices.tablet}) {
      width: 75vw;
    }
  }
  .right-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 0 0 280px;
    min-width: 280px;
    margin-left: 2vw;
    @media (${theme.devices.tablet}) {
      margin-top: 2vh;
      margin-left: 0vw;
      justify-content: flex-start;
      gap: 24px;
    }
  }
  @media (${theme.devices.tablet}) {
    display: flex;
    flex-direction: column;
    width: min(88vw, 680px);
    min-height: auto;
    padding: 32px 22px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 2vh;
  @media (${theme.devices.tablet}) {
    margin-bottom: 1vh;
  }
`;

export const RegisterInputContainer = styled(InputContainer)`
  flex-direction: column;
  width: 100%;
  row-gap: 1vh;
  @media (${theme.devices.tablet}) {
    width: 100%;
  }
`;

export const BtnsContainer = styled.div`
  display: flex;
  flex-direction: row;
  row-gap: 1vh;
  align-items: center;
  column-gap: 2vw;
  width: 100%;
  justify-content: center;

  .link {
    font-family: ${theme.fonts.gilroyRegular};
    font-size: 16px;
    /* color: ${theme.colors.blue.primary}; */
    text-decoration: none;
    cursor: pointer;

    @media (${theme.devices.tablet}) {
      margin-bottom: 2vh;
    }
  }
  @media (${theme.devices.laptopS}) {
    column-gap: 4vw;
    flex-direction: column;
    row-gap: 1vh;
  }
`;
export const BottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 95%;
  align-self: center;
  margin-bottom: 3vh;
  justify-content: space-around;

  a {
    font-family: Roboto;
    font-size: 16px;
    color: ${theme.colors.blue.primary};
    text-decoration: none;
    cursor: pointer;
  }
`;
